export default "__VITE_ASSET__DrLtfpsc__"